import { Box, MenuItem, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  gap: ${(p) => p.theme.spacing(1.5)};
  align-items: center;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  padding: ${(p) => p.theme.spacing(1, 1.5)};
  border-radius: ${(p) => p.theme.spacing(1)};
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const StartContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const EndContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledActionMenuItem = styled(MenuItem)`
  font-size: ${(p) => p.theme.typography.body4.fontSize};
  font-weight: ${(p) => p.theme.typography.fontWeightMedium};
  color: ${(p) => p.theme.palette.grey[700]};
`;
